const SMARTSUPPORT_PROVISIONING_SUBMIT = 'SMARTSUPPORT_PROVISIONING_SUBMIT';
const SMARTSUPPORT_PROVISIONING_SUBMIT_REQUESTED = 'SMARTSUPPORT_PROVISIONING_SUBMIT_REQUESTED';
const SMARTSUPPORT_PROVISIONING_SUBMIT_SUCCEEDED = 'SMARTSUPPORT_PROVISIONING_SUBMIT_SUCCEEDED';
const SMARTSUPPORT_PROVISIONING_SUBMIT_FAILED = 'SMARTSUPPORT_PROVISIONING_SUBMIT_FAILED';

export { SMARTSUPPORT_PROVISIONING_SUBMIT };
export { SMARTSUPPORT_PROVISIONING_SUBMIT_REQUESTED };
export { SMARTSUPPORT_PROVISIONING_SUBMIT_SUCCEEDED };
export { SMARTSUPPORT_PROVISIONING_SUBMIT_FAILED };
